module.exports = __webpack_public_path__ + "static/img/nav3.237dce0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav3.jpg
// module id = 28Hj
// module chunks = 62